module.exports = __webpack_public_path__ + "static/phone-58d7e3d689c0cb8eb365b86046ecdce8.svg";